<template>
    <div>
        <table class="table" v-loading="isLoading">
            <span class="text-muted" v-if="!items.length">Здесь будут отображаться сделки</span>
            <template v-for="item in items" :id="item.id">
                <DealListItem :deal="item" :source="source"/>
            </template>
        </table>
    </div>
</template>

<script>
import DealListItem from "./DealListItem";
export default {
    name: "DealList",
    components: {DealListItem},
    props: {
        source: {
            type: String,
            required: true,
            validator: function (value) {
                return ['request', 'car'].indexOf(value) !== -1
            }
        },
        source_id: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        rows: [],
        isLoading: false,
    }),
    mounted() {
        let self = this;
        if (this.source === 'request') this.fetchForRequest();
        if (this.source === 'car') this.fetchForCar();

        Echo.private(`${this.source}.${this.source_id}`)
            .listen('.deal.created', function (e) {
                self.rows.push(e.deal);
            })
            .listen('.deal.updated', function (e) {
                self.rows = self.rows.map(item => {
                    if (item.id === e.deal.id) item = e.deal;
                    return item;
                })
            });
    },
    beforeDestroy() {
        Echo.leave(`${this.source}.${this.source_id}`);
    },
    computed: {
        items() {
            return _.sortBy(this.rows, 'created_at');
        }
    },
    methods: {
        fetchForRequest() {
            let self = this;
            this.isLoading = true;
            axios.get('/api/requests/' + this.source_id + '/deals')
                .then(r => {
                    self.rows = r.data
                    self.isLoading = false;
                })
        },
        fetchForCar() {
            let self = this;
            this.isLoading = true;
            axios.get('/api/cars/' + this.source_id + '/deals')
                .then(r => {
                    self.rows = r.data
                    self.isLoading = false;
                })
        }
    }
}
</script>

<style scoped>

</style>
